.hostCard {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: var(--size-4);
}

.icon {
	border-radius: var(--radius-md);
	background-color: light-dark(var(--color-background), var(--gray-700));
	padding: var(--size-3);
	flex-shrink: 0;
}

.info {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
	flex: 1;

	> .headline {
		display: flex;
		gap: var(--size-3);
		align-items: center;

		> .title {
			all: unset;
			font-weight: normal;
			line-height: 1.25;
			font-size: var(--text-subtitle-1);

			&:focus-visible {
				outline: 2px solid var(--color-primary);
			}
		}
	}

	> .hostinfo {
		flex-wrap: wrap;
		display: flex;
		align-items: center;
		gap: var(--size-3);
		font-size: var(--text-caption);
		color: var(--color-text-subtle);
	}
}

.status {
	text-transform: uppercase;
	letter-spacing: 0.025em;
	display: flex;
	align-items: center;
	gap: var(--size-3);
	font-size: var(--text-caption);
	padding: 2px calc(var(--size-3) + 2px);
	border-radius: var(--size-10);
	font-weight: bold;
	color: var(--color-text-subtle);
	corner-shape: round;

	&::before {
		content: "";
		display: block;
		width: var(--size-3);
		height: var(--size-3);
		background-color: currentColor;
		border-radius: 100%;
		corner-shape: round;
	}

	background-color: light-dark(var(--color-background), var(--gray-700));

	&[data-online="true"] {
		background-color: var(--color-success-background);
		color: var(--color-success-foreground);

		&::before {
			background-color: var(--color-success-foreground);
		}
	}
}

.right {
	display: flex;
	align-items: center;
	gap: var(--size-4);
}

.list {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	width: 100%;
}

.item {
	padding: var(--size-4);
}
